import {
  getHsOwnerIdInLocalStorage,
  getUserInLocalStorage,
} from '../services/localStorage/localStorage';
import { getImpersonationMode } from './impersonation';

export const appendHsOwnerIdIfPresentAndAdmin = (url: string): string => {
  const user = getUserInLocalStorage();
  const hsOwnerIdInLocalStorage = getHsOwnerIdInLocalStorage();

  // Fonte unica di verità: admin, Team manager e Capo gruppo possono impersonare.
  // Senza includere il Capo gruppo qui l'impersonificazione sarebbe "muta"
  // (salvataggio ok ma dati invariati) — vedi PRD.
  if (getImpersonationMode(user) && hsOwnerIdInLocalStorage) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}hsOwnerId=${hsOwnerIdInLocalStorage}`;
  }

  return url;
};
